import { jsx as _jsx } from "react/jsx-runtime";
import { DrawingContextMenu } from "@vninvestcharts/engine-react";
export function PriceScaleMenu({ menu, isDark, t, onSelectMode, onResetZoom, onClose }) {
    if (!menu)
        return null;
    const modes = [
        { value: "linear", labelKey: "priceScale.auto" },
        { value: "log", labelKey: "priceScale.log", disabled: !menu.logAvailable },
        { value: "percent", labelKey: "priceScale.percent" },
    ];
    const items = [
        ...modes.map((mode) => ({
            key: `scale-${mode.value}`,
            label: t(mode.labelKey),
            onSelect: () => onSelectMode(mode.value),
            disabled: mode.disabled,
            // MENU_STANDARD: persistent selected tint (no "✓" text prefix).
            selected: menu.mode === mode.value,
        })),
        { key: "sep", label: "", onSelect: () => { }, type: "separator" },
        {
            key: "reset-zoom",
            label: t("priceScale.resetZoom"),
            onSelect: onResetZoom,
        },
    ];
    return (_jsx(DrawingContextMenu, { ariaLabel: t("priceScale.menuTitle"), title: t("priceScale.menuTitle"), isDark: isDark, position: { x: menu.x, y: menu.y }, 
        // openMenuAt stores viewport clientX/Y — pin to the viewport so
        // dock margins, grid offsets, sidebars and scroll can't shift it.
        positionSpace: "viewport", 
        // CHART_CLAMP: never bleed into a neighbor cell (it paints above).
        flipBounds: menu.flipRight != null || menu.flipBottom != null
            ? { right: menu.flipRight, bottom: menu.flipBottom }
            : undefined, onClose: onClose, items: items }));
}
